import { currencyOptions, rackSizeOptions } from "@/common/const";
import { includedOptions } from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const rackAndSpaceFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "Country",
    name: "country",
    required: true,
  },
  {
    inputType: "text",
    label: "Vendor Product Name",
    name: "vendorProductName",
    required: true,
  },
  {
    inputType: "text",
    label: "Quantity",
    name: "quantity",
    required: true,
  },
  {
    inputType: "select",
    label: "Rack Size",
    name: "rackSize",
    required: true,
    options: rackSizeOptions,
  },
  {
    inputType: "text",
    label: "Power",
    name: "power",
    required: true,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },
  {
    label: "Currency",
    name: "currency",
    readonly: false,
    required: false,
    inputType: "select",
    options: currencyOptions,
  },
  {
    inputType: "text",
    label: "OTE",
    name: "OTE",
    required: true,
  },
  {
    inputType: "text",
    label: "MRE",
    name: "MRE",
    required: true,
  },
  {
    inputType: "select",
    label: "Local Tax/VAT*",
    name: "isLocalTax",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Local Tax/VAT (in %)",
    name: "localTax",
    required: true,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: true,
  },
  {
    label: "Price code",
    name: "priceCode",
    required: false,
    inputType: "text",
  },
];
export default rackAndSpaceFormStrategy;
